:host {
  --aha-menu-item--color: var(--theme-primary-text);
  --aha-menu-item--background-color: none;

  color: var(--aha-menu-item--color);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: var(--Common--border-radius);
  background-color: var(--aha-menu-item--background-color);
  cursor: pointer;
}
:host ::slotted(*) {
  display: inline-flex;
  text-decoration: none;
}
:host([aria-hidden="true"]) {
  display: none;
}

:host(:focus-within),
:host(.focus-visible),
:host(:hover) {
  --aha-menu-item--background-color: var(--theme-menu-hover-background);
}
:host([selected]) {
  --aha-menu-item--background-color: var(--theme-menu-active-background);
  --aha-menu-item--color: var(--theme-menu-highlighted-text);
}

:host([type='info']) {
  --aha-menu-item--color: var(--theme-alert-info-text);
}
:host([type='info'][selected]) {
  --aha-menu-item--background-color: var(--theme-alert-info-background);
}
:host([type='success']) {
  --aha-menu-item--color: var(--theme-alert-success-text);
}
:host([type='success'][selected]) {
  --aha-menu-item--background-color: var(--theme-alert-success-background);
}
:host([type='warning']) {
  --aha-menu-item--color: var(--theme-alert-warning-text);
}
:host([type='warning'][selected]) {
  --aha-menu-item--background-color: var(--theme-alert-warning-background);
}
:host([type='danger']) {
  --aha-menu-item--color: var(--theme-alert-danger-text);
}
:host([type='danger'][selected]) {
  --aha-menu-item--background-color: var(--theme-alert-danger-background);
}
